<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="create-feed-advice__detail"
  (backAction)="back()"
  [hasPrimaryAction]="(viewMode$ | async) !== viewModes.View"
  primaryActionIcon="save"
  [primaryActionText]="'save' | translate"
  (primaryAction)="save()"
>
  <ng-container actions *ngIf="(viewMode$ | async) === viewModes.View">
    <div class="feed-advice-detail__actions">
      <button
        mat-flat-button
        color="accent"
        data-test="feed-advice-detail__print"
        (click)="printFeedAdvice()"
      >
        <mat-icon>print</mat-icon>{{ 'feed-advice.create.print' | translate }}
      </button>
    </div>
  </ng-container>

  <agr-print-page
    class="print-only"
    [footerText]="'feed-advice.create.title' | translate"
    orientation="landscape"
    [customizedLogoSrc]="customizedLogoSrc"
    [showAgrifirmLogo]="showAgrifirmLogo"
  >
    <app-feed-advice-report [feedAdvice]="feedAdvice"></app-feed-advice-report>
  </agr-print-page>

  <div
    class="spacing--margin-horizontal spacing--margin-top wrapper--spacing-horizontal screen-only"
  >
    <form [formGroup]="feedAdviceGroup">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div
          *ngIf="(viewMode$ | async) !== viewModes.View"
          class="flex--column spacing--margin-right field-width"
        >
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'feed-advice.create.name' | translate }}</mat-label>
            <input
              (keydown.enter)="$event.preventDefault()"
              matInput
              formControlName="name"
              placeholder="{{ 'feed-advice.create.name' | translate }}"
              data-test="create-feed-advice__name"
            />
            <mat-error *ngIf="feedAdviceGroup.controls.name.invalid">
              {{ 'feed-advice.create.validation-error.feedadvice-name' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="!isNewFeedAdvice" class="screen-only flex--colum">
          <p class="text--small">
            <strong>{{ 'feed-advice.create.created' | translate }}:</strong>
            {{ feedAdvice?.created | agrDate }}
          </p>
          <p class="text--small">
            <strong>{{ 'feed-advice.create.updated' | translate }}:</strong>
            {{ feedAdvice?.updated | agrDate }}
          </p>
        </div>
      </div>

      <h3 class="text--h3">{{ 'feed-advice.create.products' | translate }}</h3>
      <!-- table -->
      <agr-table (keydown.enter)="$event.preventDefault()" [config]="tableConfig"></agr-table>
      <ng-template #productNameTemplate let-row="row">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          *ngIf="(viewMode$ | async) === viewModes.Create || (viewMode$ | async) === viewModes.Edit"
          class="text--small"
          [value]="getProduct(row)"
          placeholder="{{ 'feed-advice.create.product-placeholder' | translate }}"
          (selectionChange)="selectProduct($event, row)"
          data-test="create-feed-advice__productrows_product-selector"
        >
          <mat-option *ngFor="let product of products$ | async" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
        <span *ngIf="(viewMode$ | async) === viewModes.View">
          {{ row.product?.code }} - {{ row.product?.name }}
        </span>
      </ng-template>

      <div class="flex--column" *ngIf="(viewMode$ | async) !== viewModes.View">
        <div class="mat-button-row spacing--margin-top">
          <button
            type="button"
            mat-flat-button
            color="primary"
            data-test="create-feed-advice__add-product"
            (click)="addProductRow()"
          >
            {{ 'feed-advice.create.add-product' | translate }}
          </button>
        </div>
      </div>

      <app-additive
        [viewMode]="viewMode$ | async"
        [feedAdvice]="feedAdvice"
        [additives$]="additives$"
        (additiveChanged)="updateAdditiveRows($event)"
        (showAdditiveChanged)="updateShowAdditiveRows($event)"
      ></app-additive>

      <!-- SCREEN_ONLY DESCRIPTION -->
      <div class="spacing--margin-top">
        <agr-summary-card
          *ngIf="feedAdvice?.comments || (viewMode$ | async) !== viewModes.View"
          [title]="'feed-advice.create.description' | translate"
          [canExpand]="true"
          [actions]="[]"
          class="screen-only"
        >
          <textarea
            class="text--small remarks__field"
            label="description"
            formControlName="description"
            rows="3"
            placeholder="{{ 'feed-advice.create.description-placeholder' | translate }}"
            data-test="create-feed-advice__description"
          ></textarea>
          <p *ngIf="(viewMode$ | async) === viewModes.View">
            {{ feedAdvice?.description }}
          </p>
        </agr-summary-card>
      </div>
    </form>
  </div>
</agr-page-detail>
